module.exports = __webpack_public_path__ + "static/media/equity.776a4be5.png";